"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorrespondencePermissions = void 0;
var constants_1 = require("@hobt/constants");
exports.CorrespondencePermissions = {
    CreateCorrespondence: {
        modules: [constants_1.Module.Claim],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ServiceProvider,
        ],
    },
    DeleteCorrespondence: { modules: [constants_1.Module.Claim], roles: [constants_1.UserRole.MasterUser] },
    ReadCorrespondences: {
        modules: [constants_1.Module.Claim],
        roles: [
            constants_1.UserRole.ApprovedLender,
            constants_1.UserRole.BusinessUser,
            constants_1.UserRole.Clerk,
            constants_1.UserRole.LenderAdministrator,
            constants_1.UserRole.MasterUser,
            constants_1.UserRole.ReadOnly,
            constants_1.UserRole.ServiceProvider,
        ],
    },
};
